import React, { useEffect, useState } from 'react'
import { onSnapshot, collection, where, query, orderBy } from 'firebase/firestore'
import { db } from '../system/firebase/index'
import AnimationWrapper from '../helpers/Animations'
import Testimonial from '../components/content/Testimonial'

const Testimonials = ({ options }) => {
    const [data, setData] = useState([])

    useEffect(() => {
        let isCancelled = false
        let count = 1
        const q = query(collection(db, 'posts'), where('categories', 'array-contains-any', ['testimonial']), where('visibility', '==', 'public'), orderBy('date_published', 'desc'))
        onSnapshot(q, (snapshot) => {
            if (!isCancelled) {
                const testiDoc = []
                let twoCol = {}
                snapshot.forEach((doc) => {
                    const testimonial = doc.data()
                    if ('Feed' === options.module) {
                        switch (count) {
                        case 1:
                            testiDoc.push({
                                type: 'stand-alone',
                                content: testimonial.content.description,
                                author: testimonial.title,
                                authorTitle: testimonial.content.excerpt,
                            })
                            break;
                        case 2:
                        case 5:
                            twoCol = {
                                type: '2col',
                                left: {
                                    content: testimonial.content.description,
                                    author: testimonial.title,
                                    authorTitle: testimonial.content.excerpt,
                                },
                            }
                            break;
                        case 3:
                        case 6:
                            twoCol.right = {
                                content: testimonial.content.description,
                                author: testimonial.title,
                                authorTitle: testimonial.content.excerpt,
                            }
                            testiDoc.push(twoCol)
                            twoCol = {}
                            break;

                        case 4:
                            testiDoc.push({
                                type: 'image',
                                alt: testimonial.content.excerpt,
                                media: (testimonial.media.set.length) ? testimonial.media : {
                                    set: [
                                        {
                                            filename: 'L1000080.jpg',
                                            filepath: '2020/01/',
                                            media_type: 'image',
                                            public_id: 'L1000080',
                                        },
                                    ],
                                },
                                content: testimonial.content.description,
                                author: testimonial.title,
                                authorTitle: testimonial.content.excerpt,
                            })
                            break;
                        default:
                            break;
                        }
                        if (count === 5) {
                            count = 1
                        } else {
                            count++
                        }
                    } else {
                        testiDoc.push({
                            content: testimonial.content.description,
                            author: testimonial.title,
                            authorTitle: testimonial.content.excerpt,
                        })
                    }
                })
                setData(testiDoc)
            }
        })

        return () => {
            isCancelled = true;
        }
    }, [options])

    let output = null

    if ( data.length ) {
        switch (options.module) {
        case 'Feed':
            output = []
            Object.entries(data).map(([key, testimonial]) => {
                // if (testimonial.content) {
                output.push(<AnimationWrapper key={key} type='fade-up'><Testimonial options={testimonial} /></AnimationWrapper>)
                // }
                return true
            })
            break
        default:
            output = <AnimationWrapper type='fade-up'>
                <Testimonial options={{ type: 'banner' }} testimonials={data} />
            </AnimationWrapper>
        }
    }
    return output
}

export default Testimonials
